import BrandSection from './galleryPage/BrandSection.jsx';
import ButtonsSection from './galleryPage/ButtonsSection.jsx';
import DataSection from './galleryPage/DataSection.jsx';
import FormsSection from './galleryPage/FormsSection.jsx';
import GallerySidebar from './galleryPage/GallerySidebar.jsx';
import NavigationSection from './galleryPage/NavigationSection.jsx';
import OverlaysSection from './galleryPage/OverlaysSection.jsx';
import StatusSection from './galleryPage/StatusSection.jsx';
import ThemeSwitcher from './galleryPage/ThemeSwitcher.jsx';

const GalleryPage = () => {
  return (
    <div className="gallery-page">
      <GallerySidebar />
      <main className="gallery-page__main">
        <header className="gallery-page__header">
          <div className="gallery-page__intro">
            <h1 className="gallery-page__title">Design system</h1>
            <p className="gallery-page__lede">Tokens and base components for the Pieve web app. Switch the theme to see every component in light and dark.</p>
          </div>
          <ThemeSwitcher />
        </header>
        <BrandSection />
        <StatusSection />
        <ButtonsSection />
        <FormsSection />
        <NavigationSection />
        <OverlaysSection />
        <DataSection />
      </main>
    </div>
  );
};

export default GalleryPage;
